export default "__VITE_ASSET__CMA_2HbJ__"